// extracted by mini-css-extract-plugin
export var videoContainer = "_jg-0";
export var videoIframe = "_jg-3";
export var videoLink = "_jg-1";
export var videoOverlay = "_jg-4";
export var videoOverlayText = "_jg-5";
export var videoWrapper = "_jg-2";